export default "__VITE_ASSET__BII$ifTA__"